import {gql} from "@apollo/client";
import moment from "moment";
import qs from "query-string";


export type CheckPoint = {
    ID: string
    Name: string
}

export type TimeSlot = {
    ID: string
    StartTime: string
    EndTime: string
}

export type Service = {
    ID: string
    Name: string
    Necessary: boolean
}

export type Carrier = {
    ID: string
    Name: string
}

export type DriverV1 = {
    ID: string
    Name: string
}
export type Driver = {
    code: string
    name: string
}

export type VehicleV1 = {
    ID: string
    Name: string
}

export type Vehicle = {
    plateNumber: string
    model: string
}

export type Storage = {
    ID: string
    Name: string
}

export type Cargo = {
    ID: string
    Direction: "Export" | "Import" | "Transit"
    Type: "Генеральный груз" | "Контейнер" | "Насыпной груз"
    StorageID: string
    Quantity: number
    Name: string
    Expeditor: string
}

export type CargoV2 = {
    code: string
    name: string
    direction: "Завоз" | "Вывоз" | "Транзит"
    quantity: number
    weight: number
    type: "Генеральный груз" | "Контейнер" | "Насыпной груз"
    storageName: string
    order: {
        date: string
        number: string
    }
}


export type AutoVisitStatus = "planned" | "approved" | "in_the_port" | "completed" | "canceled" | "deleted";
export const AutoVisitStatusList: AutoVisitStatus[] = [
    "planned", "approved", "in_the_port", "completed", "canceled", "deleted"
];

export type AutoVisitStatusV2 =
    "Запланирован" | "Ошибка" | "Завершен" | "В порту" | "На согласовании" | "Отменен" | "Неопределен";

export const AutoVisitStatusV2List: AutoVisitStatusV2[] = [
    "Запланирован", "Ошибка", "Завершен", "В порту", "На согласовании", "Отменен", "Неопределен"
];


export type AutoVisit = {
    ID: string
    Status: AutoVisitStatus
    status: AutoVisitStatusV2
    PIN: string
    TimeSlot: TimeSlot
    Date: string
    Carrier: Carrier
    Vehicle: VehicleV1
    Driver: DriverV1
    CargoInfo: string
    AutoVisitInfo: string
    CheckPoint: CheckPoint
    CargoList: {
        ID: string
        CargoID: string
        Name: string
        Direction: Cargo["Direction"]
        Type: Cargo["Type"]
        StorageID: string
        Quantity: number
        Address: string
        Canceled: boolean
    }[]
    ServiceList: {
        ID: string
        CargoID: string
        ServiceID: string
        Name: string
        Quantity: number
        Price: number
        Sum: number
        Canceled: boolean
        Necessary: boolean
    }[]
}

export type ShortAutoVisit = {
    id: string
    number: string
    date: string
    status: AutoVisitStatusV2
    pin: string
    cargoInfo: string
    timeSlotId: string
    vehicleId: string
    checkPointName: string
    driverName: string
}


const TRANSFORM_VEHICLE_MAPPING = {
    ID: "plateNumber",
    Name: "model"
}
export function old2newVehicle(value: VehicleV1): Vehicle {
    if (value == null) {
        return null;
    }
    const ret = {}
    for (const [oldName, newName] of Object.entries(TRANSFORM_VEHICLE_MAPPING)) {
        ret[newName] = value[oldName];
    }
    return ret as any;
}
export function new2oldVehicle(value: Vehicle): VehicleV1 {
    if (value == null) {
        return null;
    }
    const ret = {}
    for (const [oldName, newName] of Object.entries(TRANSFORM_VEHICLE_MAPPING)) {
        ret[oldName] = value[newName];
    }
    return ret as any;
}


const TRANSFORM_DRIVER_MAPPING = {
    ID: "code",
    Name: "name"
}
export function old2newDriver(value: DriverV1): Driver {
    if (value == null) {
        return null;
    }
    const ret = {}
    for (const [oldName, newName] of Object.entries(TRANSFORM_DRIVER_MAPPING)) {
        ret[newName] = value[oldName];
    }
    return ret as any;
}
export function new2oldDriver(value: Driver): DriverV1 {
    if (value == null) {
        return null;
    }
    const ret = {}
    for (const [oldName, newName] of Object.entries(TRANSFORM_DRIVER_MAPPING)) {
        ret[oldName] = value[newName];
    }
    return ret as any;
}


export const GetAutoVisitListDocument = gql`
    query AutoVisitList($carrierId: String!, $dateFrom: Date, $dateTo: Date, $page: String, $query: String, $status: [String!]) {
        autovisits(carrier_id: $carrierId, date_from: $dateFrom, date_to: $dateTo, page: $page, query: $query, status: $status) @rest(pathBuilder: $pathBuilder) {
            autovisits @type(name: "AutoVisit") {
                id
                number
                date
                status
                pin
                cargoInfo
                timeSlotId
                checkPointName
                vehicleId
                driverName
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`;
export function autoVisitsListPathBuilder({args}) {
    const url = "remote/av/api/v2/autovisits";
    const params = {
        offset: "20"
    };
    const format = "YYYY-MM-DD";
    if (args.date_from) {
        params["date-from"] = moment(args.date_from).format(format);
    }
    if (args.date_to) {
        params["date-to"] = moment(args.date_to).format(format);
    }
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.status) {
        params["status"] = Array.isArray(args.status) ? args.status.join(",") : args.status;
    }
    if (args.page) {
        params["page"] = args.page;
    }
    return url + "?" + qs.stringify(params);
}
export type GetAutoVisitsQueryVars = {
    carrierId: string
    page?: string
    dateFrom?: number
    dateTo?: number
    query?: string
    status?: string | string[]
    pathBuilder: typeof autoVisitsListPathBuilder
}
export type GetAutoVisitsQueryResult = {
    autovisits: {
        autovisits: ShortAutoVisit[],
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
};


export const GetAutoVisitDocument = gql`
    query GetAutoVisit($id: String!) {
        autoVisit(id: $id) @rest(path: "remote/av/VMTP_API/autovisits/{args.id}") {
            Autovisit @type(name: "AutoVisit") {
                ID
                Date
                Status
                StatusV2: status
                PIN
                TimeSlot {
                    ID
                    StartTime
                    EndTime
                }
                Carrier {
                    ID
                    Name
                }
                Vehicle {
                    ID
                    Name
                }
                Driver {
                    ID
                    Name
                }
                CheckPoint {
                    ID
                    Name
                }
                CargoInfo
                AutoVisitInfo: AutovisitInfo
                CargoList {
                    ID
                    CargoID
                    Name
                    Direction
                    StorageID
                    Quantity
                    Address
                    Canceled
                    Type
                }
                ServiceList {
                    ID
                    ServiceID
                    CargoID
                    Name
                    Quantity
                    Price
                    Sum
                    Canceled
                    Necessary
                }
                id
                number
                date
                status
                pin
                cargoInfo
                timeSlotId
                checkPointName
                vehicleId
                driverName
            }
        }
    }
`;
export type GetAutoVisitQueryVars = {
    id: string
}
export type GetAutoVisitQueryResult = {
    autoVisit: {
        Autovisit: AutoVisit
    }
}


export const GetCargoListDocument = gql`
    query GetCargos($autoVisitId: String, $date: String, $page: Int, $query: String, $direction: [String!], $excludeIds: [String!], $type: [String!], $empty: Boolean) {
        cargos(autovisit_id: $autoVisitId, date: $date, page: $page, query: $query, direction: $direction, exclude_ids: $excludeIds, type: $type, empty: $empty) @rest(pathBuilder: $pathBuilder) {
            cargos @type(name: "AutoVisitCargo") {
                code
                name
                direction
                weight
                type
                quantity
                storageName
                order {
                    date
                    number
                }
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`;
export function GetCargoListPathBuilder({args}) {
    const url = [
        "remote/av/api/v2/cargos",
    ].join("/");
    const params = {
        offset: "20"
    };
    if (args.autovisit_id) {
        params["avtovisit-id"] = args.autovisit_id;
    }
    if (args.exclude_ids?.length) {
        params["exclude-cargo"] = args.exclude_ids.join(",");
    }
    if (args.date) {
        params["date"] = moment(args.date).format("YYYY-MM-DD");
    }
    if (args.page) {
        params["page"] = args.page;
    }
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.direction?.length) {
        params["direction"] = args.direction.join(",");
    }
    if (args.type?.length) {
        params["type"] = args.type.join(",");
    }
    if (args.empty != null) {
        params["empty"] = args.empty;
    }

    return url + "?" + qs.stringify(params);
}

export type GetCargoListVars = {
    autoVisitId?: string
    direction?: string[]
    type?: CargoV2["type"][]
    date?: number
    page?: number
    query?: string
    empty?: boolean
    excludeIds: string[]
    pathBuilder: typeof GetCargoListPathBuilder,
}
export type GetCargoListResult = {
    cargos: {
        cargos: CargoV2[]
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}


export const GetServiceListDocument = gql`
    query GetServiceList($cargoId: String!, $carrierId: String!, $autoVisitId: String) {
        services(cargo_id: $cargoId, carrier_id: $carrierId, autovisit_id: $autoVisitId) @rest(pathBuilder: $pathBuilder) {
            ServiceList {
                ID
                Name
                Necessary
            }
        }
    }
`
export function GetServiceListPathBuilder({args}) {
    const url = [
        "remote/av/VMTP_API/carriers",
        encodeURI(args.carrier_id),
        "cargos",
        encodeURI(args.cargo_id),
        "services",
    ].join("/");
    if (args.autovisit_id) {
        return url + `?autovisit_id=${encodeURIComponent(args.autovisit_id)}`
    }
    return url;
}
export type GetServiceListQueryVars = {
    cargoId: string
    carrierId: string
    autoVisitId?: string
    pathBuilder: typeof GetServiceListPathBuilder
}
export type GetServiceListQueryResult = {
    services?: {
        ServiceList: Service[]
    },
    ErrorInfo?: {
        ID: string
        Description: string
    }
}


export const GetTimeSlotsDocument = gql`
    query GetTimeSlots($carrierId: String!, $cargoId: String!, $serviceIds: [String!]!, $autoVisitId: String, $autoVisitDate: String) {
        timeSlots(carrier_id: $carrierId, cargo_id: $cargoId, service_ids: $serviceIds, autovisit_id: $autoVisitId, date: $autoVisitDate) @rest(pathBuilder: $pathBuilder) {
            TimeSlotList {
                ID
                StartTime
                EndTime
            }
        }
    }
`
export function GetTimeSlotsPathBuilder({args}) {
    const url = [
        "remote/av/VMTP_API/carriers",
        encodeURI(args.carrier_id),
        "cargos",
        encodeURI(args.cargo_id),
        "services",
        encodeURI(args.service_ids.join(",")),
        "timeslots"
    ].join("/");
    const params = {
        date: args.date
    };

    if (args.autovisit_id) {
        params["autovisit_id"] = args.autovisit_id;
    }
    return url + "?" + qs.stringify(params);
}
export type GetTimeSlotsQueryVars = {
    cargoId: string
    carrierId: string
    serviceIds: string[]
    autoVisitId?: AutoVisit["ID"]
    autoVisitDate: string
    pathBuilder: typeof GetTimeSlotsPathBuilder
}
export type GetTimeSlotsQueryResult = {
    timeSlots: {
        TimeSlotList?: {
            ID: string
            StartTime: string
            EndTime: string
        }[]
    }
}


export const GetVehiclesDocument = gql`
    query GetVechicles {
        vehicles @rest(path: "remote/av/api/v2/vehicles?driver") {
            vehicles {
                plateNumber
                model
                driver {
                    code
                    name
                }
            }
        }
    }
`;
export type GetVehiclesQueryVars = {}
export type GetVehiclesQueryResult = {
    vehicles: {
        vehicles: (Vehicle & {
            driver?: {
                code: string
                name: string
            }
        })[]
    }
}


export const GetDriversDocument = gql`
    query GetDrivers($carrierId: String!) {
        drivers(carrier_id: $carrierId) @rest(path: "remote/av/api/v2/drivers") {
            drivers {
                code
                name
            }
        }
    }
`;
export type GetDriversQueryVars = {}
export type GetDriversQueryResult = {
    drivers: {
        drivers: Driver[]
    }
}


export const CreateAutoVisitDocument = gql`
    mutation CreateAutoVisit($input: CreateAutoVisitInput!) {
        CreateAutoVisit(input: $input) @rest(path: "remote/av/VMTP_API/autovisits", method: "POST") {
            Autovisit @type(name: "AutoVisit") {
                id: ID
                ID
                Date
                Status
                StatusV2: Status_v2
                PIN
                TimeSlot {
                    StartTime
                    EndTime
                }
                Carrier {
                    ID
                    Name
                }
                Vehicle {
                    ID
                    Name
                }
                Driver {
                    ID
                    Name
                }
                CheckPoint {
                    ID
                    Name
                }
                CargoInfo
                AutoVisitInfo: AutovisitInfo
                CargoList {
                    ID
                    CargoID
                    Name
                    Direction
                    StorageID
                    Quantity
                    Address
                    Canceled
                }
                ServiceList {
                    ID
                    ServiceID
                    Name
                    Quantity
                    Price
                    Sum
                    Canceled
                    Necessary
                    CargoID
                }
            }
        }
    }
`
export type CreateAutoVisitMutationVars = {
    input: {
        Date: string
        TimeSlotID: string
        CarrierID: string
        VehicleID: string
        DriverID: string
        CheckPointID: string
        Cargos: {
            ID: string
            StorageID: string
            Quantity: number
            Description: string
            Address: {
                PostalCode?: string
                Region?: string
                District?: string
                City?: string
                Settlement?: string
                Street?: string
                House?: string
                Building?: string
                Apartment?: string
            }
        }[]
        Services: {
            ID: string
            CargoID: string
            Quantity: number
        }[]
    }
}
export type CreateAutoVisitMutationResult = {
    CreateAutoVisit: {
        Autovisit?: Omit<AutoVisit, "CargoList" | "ServiceList">,
    }
}


export const UpdateAutoVisitDocument = gql`
    mutation UpdateAutoVisit($input: UpdateAutoVisitInput!, $id: String) {
        UpdateAutoVisit(input: $input, id: $id) @rest(path: "remote/av/VMTP_API/autovisits/{args.id}", method: "PUT") {
            Autovisit @type(name: "AutoVisit") {
                id: ID
                ID
                Date
                Status
                StatusV2: Status_v2
                PIN
                TimeSlot {
                    StartTime
                    EndTime
                }
                Carrier {
                    ID
                    Name
                }
                Vehicle {
                    ID
                    Name
                }
                Driver {
                    ID
                    Name
                }
                CheckPoint {
                    ID
                    Name
                }
                CargoInfo
                AutoVisitInfo: AutovisitInfo
                CargoList {
                    ID
                    CargoID
                    Name
                    Direction
                    StorageID
                    Quantity
                    Address
                    Canceled
                }
                ServiceList {
                    ID
                    ServiceID
                    Name
                    Quantity
                    Price
                    Sum
                    Canceled
                    Necessary
                    CargoID
                }
            }
        }
    }
`
export type UpdateAutoVisitQueryVars = {
    id: string
    input: {
        Date: string
        TimeSlotID: string
        CarrierID: string
        VehicleID: string
        DriverID: string
        CheckPointID: string
        Cargos: {
            ID: string
            StorageID: string
            Quantity: number
            Description: string
            Address: {
                PostalCode?: string
                Region?: string
                District?: string
                City?: string
                Settlement?: string
                Street?: string
                House?: string
                Building?: string
                Apartment?: string
            }
        }[]
        Services: {
            ID: string
            CargoID: string
            Quantity: number
        }[]
    }
}
export type UpdateAutoVisitQueryResult = {
    UpdateAutoVisit: {
        Autovisit?: Omit<AutoVisit, "CargoList" | "ServiceList">
        ErrorInfo?: {
            ID: string
            Description: string
        }
    }
}


export const GetCheckPointListDocument = gql`
    query GetCheckPointList($carrierId: String!, $cargoIds: [String!]!, $timeslotId: String!, $autoVisitId: String, $autoVisitDate: String) {
        checkPoints(carrier_id: $carrierId, cargo_id: $cargoIds, timeslot_id: $timeslotId, autovisit_id: $autoVisitId, date: $autoVisitDate)
        @rest(pathBuilder: $pathBuilder)
        {
            CheckPointList {
                ID
                Name
            }
        }
    }
`

export function GetCheckPointPathBuilder({args}) {
    const url = [
        "remote/av/VMTP_API/carriers",
        encodeURI(args.carrier_id),
        "cargos",
        encodeURI(args.cargo_id.join(",")),
        "timeslots",
        encodeURI(args.timeslot_id),
        "checkpoints"
    ].join("/");
    const params = {
        date: args.date
    };
    if (args.autovisit_id) {
        params["autovisit_id"] = args.autovisit_id;
    }
    return url + "?" + qs.stringify(params);
}

export type GetCheckPointListVars = {
    carrierId: Carrier["ID"],
    cargoIds: Cargo["ID"][],
    autoVisitId?: AutoVisit["ID"]
    timeslotId: TimeSlot["ID"]
    autoVisitDate: string
    pathBuilder: typeof GetCheckPointPathBuilder
}
export type GetCheckpointListResult = {
    checkPoints?: {
        CheckPointList: CheckPoint[]
    },
    ErrorInfo?: {
        ID: string
        Description: string
    }
}


export const CancelAutoVisitDocument = gql`
    mutation CancelAutoVisit($id: String!) {
        cancelAutoVisit(id: $id) @rest(path: "remote/av/VMTP_API/autovisits/{args.id}", method: "DELETE") {
            nope
        }
    }
`
export type CancelAutoVisitVars = {
    id: AutoVisit["ID"]
}
export type CancelAutoVisitResult = {
    cancelAutoVisit: {
        ErrorInfo?: {
            ID: string
            Description: string
        }
    }
}